import { locale } from "../locales/index.js";
import store from "@/store";

function handleLanguage(to, next, defaultPath) {
  const lang = to.params.lang;
  if (Object.keys(locale.messages).includes(lang)) {
    locale.locale = lang;
    localStorage.setItem("language", lang.toLowerCase());
    next();
  } else {
    next(defaultPath + to.hash);
  }
}

/* function handleLanguage(to, next, defaultPath) {
  const lang = to.params.lang;

  // Проверяем, является ли lang допустимым языком
  if (lang && Object.keys(locale.messages).includes(lang)) {
    locale.locale = lang;
    localStorage.setItem("language", lang.toLowerCase());
    next();
  } else {
    next(defaultPath + to.fullPath.substring((lang || "").length));
  }
} */

const frontend_router = [
  {
    path: "/:lang?",
    name: "home",
    component: () => import("../views/Home.vue"),
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en"),
  },
  {
    path: "/:lang?/about",
    name: "about",
    component: () => import("../views/About.vue"),
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/about"),
  },
  {
    path: "/:lang?/budget",
    name: "budget",
    component: () => import("../views/Budget.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/budget"),
  },
  {
    path: "/:lang?/location",
    name: "location",
    component: () => import("../views/Location.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/location"),
  },
  {
    path: "/:lang?/quality",
    name: "quality",
    component: () => import("../views/Quality.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/quality"),
  },
  {
    path: "/:lang?/rules",
    name: "rules",
    component: () => import("../views/Rules.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/rules"),
  },
  {
    path: "/:lang?/news",
    name: "news",
    component: () => import("../views/News.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/news"),
  },
  {
    path: "/:lang?/news/:id",
    name: "read_article",
    component: () => import("../views/ReadArticle.vue"), ///////
    beforeEnter: async (to, from, next) => {
      /* try {
        const response = await new Promise((resolve) =>
          setTimeout(() => resolve({ title: 'Dynamic Page Title' }), 1000)
        );
        to.meta.pageData = response; // Передаём данные в мета маршрута
      } catch (error) {
        console.error('Ошибка:', error);
      } */
      handleLanguage(to, next, "/ru/news");
    },
  },
  {
    path: "/:lang?/b&b",
    name: "B&B",
    component: () => import("../views/B&B.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/b&b"),
  },
  {
    path: "/:lang?/contact",
    name: "contact",
    component: () => import("../views/Contact.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/contact"),
  },
  {
    path: "/:lang?/legal/:name?",
    name: "legal",
    component: () => import("../views/Legal.vue"), ///////
    beforeEnter: (to, from, next) => handleLanguage(to, next, "/en/legal"),
  },
  {
    path: "/:lang?/platform_auth",
    name: "platform_auth",
    component: () => import("../views/Platform/SignInPlanform.vue"),
    beforeEnter: async (to, from, next) => {
      let responce = await store.dispatch("UserCkeck");
      if (responce?.status === 200) {
        next({
          name: "platform",
        });
      } else {
        handleLanguage(to, next, "/en/platform_auth");
      }
    },
  },
  {
    path: "/:lang?/platform",
    name: "platform",
    component: () => import("../views/Platform/WebPlatform.vue"),
    beforeEnter: async (to, from, next) => {
      let responce = await store.dispatch("UserCkeck");
      if (responce?.status === 200) {
        handleLanguage(to, next, "/en/platform");
      } else {
        next({
          name: "platform_auth",
        });
      }
    },
  },
];

export default frontend_router;
